<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="140px"
      label-position="right"
      :label-suffix="(type == 'preview' ? '：' : '')"
    >
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="成熟度"
            :prop="type != 'preview' ? 'ripenesslvlSpecValKeyList' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-select
              v-if="type != 'preview'"
              v-model="form.ripenesslvlSpecValKeyList"
              collapse-tags
              filterable
              placeholder="请选择成熟度"
              @change="ripenessLevelChange"
            >
              <el-option
                v-for="item in ripenessLevel"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
            <span v-else>{{form.ripenessLevelSpecAttrValueKey }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            label="果树树龄"
            :prop="type != 'preview' ? 'cropAgeValue' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <el-select
              v-if="type != 'preview'"
              v-model="form.cropAgeValue"
              collapse-tags
              filterable
              placeholder="请选择树龄"
            >
              <el-option
                v-for="item in treeAge"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
            <span v-else>{{ form.cropAgeValue }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="鲜皮率(%)"
            :prop="type != 'preview' ? 'freshPeelMinFairValue' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <div class="remarkNoLineH">
              <el-input
                type="number"
                v-if="type != 'preview'"
                v-model="form.freshPeelMinFairValue"
                placeholder="最低"
              ></el-input>
              <span v-if="type != 'preview'">~</span>
              <el-input
                type="number"
                v-if="type != 'preview'"
                v-model="form.freshPeelMaxFairValue"
                placeholder="最高"
              ></el-input>
              <span v-else>{{ form.freshPeelMinFairValue }}~{{form.freshPeelMaxFairValue}}</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="干皮出皮率(%)"
            :prop="type != 'preview' ? 'dryPeelMinFairValue' : ''"
            :class="{'mb-0':type == 'preview'}"
          >
            <div class="remarkNoLineH">
              <el-input
                type="number"
                v-if="type != 'preview'"
                v-model="form.dryPeelMinFairValue"
                placeholder="最低"
              ></el-input>
              <span v-if="type != 'preview'">~</span>
              <el-input
                type="number"
                v-if="type != 'preview'"
                v-model="form.dryPeelMaxFairValue"
                placeholder="最高"
              ></el-input>
              <span v-else>{{ form.dryPeelMinFairValue }}~{{form.dryPeelMaxFairValue}}</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注" class="remarkNoLineH" :class="{'mb-0':type == 'preview'}">
            <el-input
              v-if="type != 'preview'"
              v-model="form.remark"
              placeholder="请输入"
              maxlength="300"
              type="textarea"
              resize="none"
              rows="3"
            ></el-input>
            <span v-else>{{ form.remark ? form.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" v-if="type == 'preview'" class="form-operation">
        <el-col :span="12">
          <el-form-item label="操作人" class="mb-0">
            <span>{{ parseStrEmpty(form.updateBy) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作时间" class="mb-0">
            <span>{{ parseStrEmpty(form.updateTime) }}</span>
          </el-form-item>
        </el-col>
      </el-row>-->
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { reasonableSave, reasonablEdit } from '@/api/system/reasonable'
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      form: {
        remark: '',
        cropAgeValue: '',
        dryPeelMaxFairValue: '',
        dryPeelMinFairValue: '',
        freshPeelMaxFairValue: '',
        freshPeelMinFairValue: '',
        ripenesslvlSpecValKeyList: '',
        ripenessLevelSpecAttrValueKey: '',
      },
      rules: {
        cropAgeValue: [{ required: true, message: '请输人', trigger: 'change' }],
        dryPeelMaxFairValue: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        dryPeelMinFairValue: [{ required: true, message: '请选择', trigger: 'blur' }],
        freshPeelMaxFairValue: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        freshPeelMinFairValue: [{ required: true, message: '请选择', trigger: 'blur' }],
        ripenesslvlSpecValKeyList: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    }
  },
  computed: {
    ...mapState({
      treeAge: (state) => (state.system.dictList && state.system.dictList.treeAge) || [],
      ripenessLevel: (state) => (state.system.dictList && state.system.dictList.ripenessLevel) || [],
    }),
  },
  created() {},

  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    add() {},
    ripenessLevelChange(val) {
      this.ripenessLevel.forEach((d) => {
        if (d.dictValue == val) {
          this.form.ripenessLevelSpecAttrValueKey = d.dictLabel
        }
      })
    },
    getDetail(row) {
      if (row) {
        this.form = Object.assign(this.form, row)
      }
    },
    submit(type, callback) {
      if (
        Number(this.form.freshPeelMaxFairValue) < Number(this.form.freshPeelMinFairValue) ||
        Number(this.form.dryPeelMaxFairValue) < Number(this.form.dryPeelMinFairValue)
      ) {
        this.$message.error('最大值不能小于最小值')
        return
      }
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let result = null
          if (this.type == 'add') {
            result = await reasonableSave(this.form)
          } else {
            result = await reasonablEdit(this.form)
          }

          if (result.code == 200 && result.flag) {
            console.log('进来执行callback-----------')
            this.$message.success('操作成功')
            this.reset()
            callback(true)
          } else {
            this.$message.error(result.message)
          }
        }
      })
    },
    reset() {
      this.form = {
        remark: '',
        cropAgeValue: '',
        dryPeelMaxFairValue: '',
        dryPeelMinFairValue: '',
        freshPeelMaxFairValue: '',
        freshPeelMinFairValue: '',
        ripenesslvlSpecValKeyList: '',
      }
      this.resetForm('form')
    },

    cancel() {},
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-input--suffix .el-input__inner {
  width: 363px;
}
::v-deep {
  .remarkNoLineH {
    .el-input {
      width: 175px;
    }
  }
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
</style>